if (!customElements.get('online-card-tabs')) {
  class OnlineCardTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });
    }

    onKeydown(event, index) {
      const offsets = { ArrowRight: 1, ArrowLeft: -1 };
      if (!(event.key in offsets)) return;
      event.preventDefault();
      const next = this.tabs[(index + offsets[event.key] + this.tabs.length) % this.tabs.length];
      this.select(next);
      next.focus();
    }

    select(activeTab) {
      this.tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
        document.getElementById(tab.getAttribute('aria-controls')).hidden = !isActive;
      });
    }
  }

  customElements.define('online-card-tabs', OnlineCardTabs);
}
